import { Sidebar, Content, Navbar } from "../Components/Dashboard";
import { useState } from "react";
import useAuth from "../Hooks/useAuth";
import { Home } from "../Components/Dashboard/Menu/Home";
import { Navigate } from "react-router-dom";
import { Lembaga } from "../Components/Dashboard/Menu/Lembaga/Lembaga";
import { Prestasi } from "../Components/Dashboard/Menu/Prestasi";

export const Dashboard = () => {
    const { auth } = useAuth();
    const [menu, setMenu] = useState("utama");
    const [isSidebarOpen, setSidebarOpen] = useState(false);

    const renderContent = () => {
        if (menu === "utama") {
            return <Home />;
        } else if (menu === "lembaga") {
            return <Lembaga />;
        } else if (menu === "prestasi") {
            return <Prestasi />;
        }
    };

    return auth?.success ? (
        <div className="flex h-screen">
            {/* Sidebar */}
            <Sidebar
                isOpen={isSidebarOpen}
                onToggleSidebar={() => setSidebarOpen(!isSidebarOpen)}
                currentMenu={menu}
                setMenu={setMenu}
                role={auth.role}
            />

            {/* Main Content */}
            <div className="flex-1 flex flex-col">
                <Navbar
                    onToggleSidebar={() => setSidebarOpen(!isSidebarOpen)}
                    username={auth.username}
                />
                <Content menu={menu}>{renderContent()}</Content>
            </div>
        </div>
    ) : (
        <Navigate to="/login" />
    );
};
